<template>
  <div class="addMember">
    <el-dialog
        width="800px"
        :title="dialog.title"
        :visible.sync="dialog.show"
        :close-on-click-modal='dialog.clickModal'
        :close-on-press-escape='dialog.pressEscape'
        :modal-append-to-body="false">
        <el-tabs tab-position="top">
        <el-tab-pane label="登记用户">
          <member :member="member" operation="add" @result='reserve'></member>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import Member from "./Member.vue";

export default {
  name: "addMember",
  props: {
    dialog: Object
  },
  components:{
    Member
  },
  data() {
    return {
        member: {}
    };
  },
  methods: {
    reserve: function(val) {
      this.$emit("result", 'add');
    }
  },
  created(){

  }
};
</script>
<style lang="scss">
.addMember {
  .el-dialog__headerbtn{
    z-index:999;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__header {
    padding: 0px;
  }
}

</style>
